import { last } from 'lodash';
import config from 'config';

// api3 image fields are inconsistent: some resolvers return a bucket-relative path, others a full
// s3 URL. useImageUrlBuilder passes anything starting with "http" straight through, silently
// skipping the resize/webp transforms — so absolute URLs have to be reduced to a path first.
export function toRelativeImagePath(url: string): string {
  if (!url) return url;
  const withoutProtocol = config.s3Root.replace(/^https?:/, '');
  return last(url.split(`${withoutProtocol}/`));
}
